/* Book Kit PDP — small enhancements. Only loaded when the section's
   "Layout style" is set to "Book kit (new PDP)".
   NOTE: Add to cart price text is handled ONLY in custom.js. */
(function () {
  function initCounter(section) {
    var counter = section.querySelector('.bk-gallery-counter__current');
    var container = section.querySelector('.shop-image-container');
    if (!counter || !container) return;
    var images = Array.prototype.slice.call(container.querySelectorAll('.shop-main-image'));
    if (!images.length) return;

    function update() {
      for (var i = 0; i < images.length; i++) {
        if (images[i].classList.contains('active')) {
          counter.textContent = String(i + 1);
          return;
        }
      }
    }

    new MutationObserver(update).observe(container, {
      subtree: true,
      attributes: true,
      attributeFilter: ['class']
    });
    update();
  }

  function init() {
    var sections = document.querySelectorAll('.shop-product-section.bk-pdp');
    Array.prototype.forEach.call(sections, function (section) {
      if (section.getAttribute('data-bk-ready') === 'true') return;
      section.setAttribute('data-bk-ready', 'true');
      initCounter(section);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
  document.addEventListener('shopify:section:load', init);
})();